export const gastosCovid_item = [
  
    {
      gastosCovid_item_title: "Transparencia Proactiva",
      gastosCovid_item_table: [

        {
          gastosCovid_item_content: "1. Recursos Autorizados por Fuente de Financiamiento",
          gastosCovid_item_url_xls: "/contenido/transparencia/covid19/1.- Recursos Autorizados por Fuente de Financiamiento.xlsx",
          gastosCovid_item_url_pdf: "/contenido/transparencia/covid19/1.- Recursos Autorizados por Fuente de Financiamiento.pdf",
        },
        {
          gastosCovid_item_content: "2. Recursos Autorizados por Partida y Fuente de Financiamiento Estatal y Federal",
          gastosCovid_item_url_xls: "/contenido/transparencia/covid19/2.- Recursos Autorizados por  Partida y Fuente de Financiamiento Estatal y Federal.xlsx",
          gastosCovid_item_url_pdf: "/contenido/transparencia/covid19/2.- Recursos Autorizados por  Partida y Fuente de Financiamiento Estatal y Federal.pdf",
        },
        {
          gastosCovid_item_content: "3. Gasto en Servicios Personales, Bienes y Servicios",
          gastosCovid_item_url_xls: "/contenido/transparencia/covid19/3.- Gasto en Servicios Personales, Bienes y Servicios.xlsx",
          gastosCovid_item_url_pdf: "/contenido/transparencia/covid19/3.- Gasto en Servicios Personales, Bienes y Servicios.pdf",
        },
        {
          gastosCovid_item_content: "4. Recurso Autorizado Estatal y Federal Clasificado por Concepto (Desglosado)",
          gastosCovid_item_url_xls: "/contenido/transparencia/covid19/4.- Recurso Autorizado Estatal y Federal Clasificado por Concepto (Desglosado).xlsx",
          gastosCovid_item_url_pdf: "/contenido/transparencia/covid19/4.- Recurso Autorizado Estatal y Federal Clasificado por Concepto (Desglosado).pdf",
        },
        {
          gastosCovid_item_content: "5. Recurso Estatal y Federal Autorizado por Tipo de Unidad Presupuestal",
          gastosCovid_item_url_xls: "/contenido/transparencia/covid19/5.- Recurso Estatal y Federal Autorizado por Tipo de Unidad Presupuestal.xlsx",
          gastosCovid_item_url_pdf: "/contenido/transparencia/covid19/5.- Recurso Estatal y Federal Autorizado por Tipo de Unidad Presupuestal.pdf",
        },
        
      ],
    },
  ]  

  
  